import styled from 'styled-components';

export const ContactForm = styled.div`
  border-top: 1px solid #e1e7ee;
  padding: 2em;
  width: 100%;
  label {
    font-size: 1.4rem;
    color: #141823;
    padding-bottom: 1rem;
  }
  input {
    border: 1px solid #e5edf6;
    border-radius: 0.4rem;
    padding: 1rem;
    width: 100%;
    font-size: 1.4rem;
    height: 3.5rem;
    background: white;
    outline: 0;
    &.error {
      border: 1px solid #ff3a5c;
    }
  }
`;

export const Container = styled.div`
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
`;

export const Email = styled.div`
  display: flex;
  flex-direction: column;
  width: 54%;
  margin-bottom: 2rem;
`;

export const MobileNumber = styled.div`
  display: flex;
  flex-direction: column;
  width: 42%;
  margin-bottom: 2rem
`;
export const Error = styled.p`
  font-size: 1.2rem;
  color: #ff3a5c;
  padding-top: 0.5rem;
`;
export const CustomSelect = styled.div`
  padding: 0;
  margin: 0;
  width: 6.3rem;
  overflow: hidden;
  background-color: #eef4fd;
  border: 1px solid #e5edf6;
  height: 3.5rem;
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
  position: absolute;
  left: 0;
  select {
    padding: 1rem;
    width: 100%;
    font-size: 1.4rem;
    outline: 0;
    border: 0;
    background: transparent;
    background-image: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  &.error{
    border: 1px solid #ff3a5c;
    border-right: 0px;
  }
`;
export const DropIconWrap = styled.div`
  position: absolute;
  right: 10%;
  top: 35%;
`;
export const MobileWrap = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  input {
    margin-left: 6rem;
  }
  

`;
export const Block = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  margin-bottom: 2rem;
`;
